if(!customElements.get('product-compare')) {
  customElements.define('product-compare', class ProductCompare extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.data = {
        columnArr: this.querySelectorAll(`.compare-column`) || [],
        columnCount: this.querySelectorAll(`.compare-column`)?.length || 0,
        rowCountPerColumn: this.querySelector(`.compare-column`)?.querySelectorAll(`.row-item`)?.length || 0
      }
      window.addEventListener('DOMContentLoaded', ()=> {
        this.initRowItemHeight();
        this.initTableControls();
      });
      window.addEventListener('resize', this.debounce(this.handleResize, 200).bind(this));
    }

    handleResize() {
      this.initRowItemHeight();
      this.initTableControls();
    }

    initRowItemHeight() {
      if(this.data.columnCount > 0 && this.data.rowCountPerColumn > 0) {
        let heightArr = [];
        for(let i = 0; i < this.data.rowCountPerColumn; i++) {
          var height = 0;
          for (let j = 0; j < this.data.columnCount; j++) {
            let tempEl = this.data.columnArr[j]?.querySelectorAll(`.row-item`)[i];
            if(height < tempEl.getBoundingClientRect().height){height = tempEl.getBoundingClientRect().height;}
          }
          heightArr.push(height);
        }
        for(let x = 0; x < this.data.rowCountPerColumn; x++) {
          for (let y = 0; y < this.data.columnCount; y++) {
            let tempEl = this.data.columnArr[y]?.querySelectorAll(`.row-item`)[x];
            tempEl.style.height = `${heightArr[x]}px`;
          }
        }
      }
    }

    initTableControls() {
      if(window.innerWidth <= 1000) {
        var scrollContainer = this.querySelector('.compare-wrapper');
        var scrollLeftBtn = this.querySelector('.slick-prev');
        var scrollRightBtn = this.querySelector('.slick-next');
        var currscrollLeft = scrollContainer.scrollLeft || 0;
        var maxScrollLeft = scrollContainer.scrollWidth - scrollContainer.clientWidth;
        var scrollAmount = 200; // 每次滚动的距离
        scrollLeftBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          // 判断是否已经在最左侧，如果在最左侧 则scrollLeft 设置为最小值
          if(currscrollLeft - scrollAmount <= 0) {
            scrollContainer.scrollLeft = 0;
          } else {
            currscrollLeft -= scrollAmount; 
            scrollContainer.scrollBy({
              left: -scrollAmount,
              behavior: 'smooth'
            });
          }
        });
        scrollRightBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          // 判断是否已经在最右侧，如果在最右侧 则scrollLeft 设置为最大值
          if(currscrollLeft + scrollAmount >= maxScrollLeft) {
            scrollContainer.scrollLeft = maxScrollLeft;
          } else {
            currscrollLeft += scrollAmount;
            scrollContainer.scrollBy({
              left: scrollAmount,
              behavior: 'smooth'
            });
          }
        });
        // Scroll event listener to update the button states
        scrollContainer.addEventListener('scroll', this.debounce(()=> {
          // Disable the left button if fully scrolled to the left
          if (scrollContainer.scrollLeft <= 0) {
            scrollLeftBtn.disabled = true;
          } else {
            scrollLeftBtn.disabled = false;
          }
          // Disable the right button if fully scrolled to the right
          if (Math.ceil(scrollContainer.scrollLeft) + scrollContainer.clientWidth >= scrollContainer.scrollWidth) {
            scrollRightBtn.disabled = true;
          } else {
            scrollRightBtn.disabled = false;
          }
          currscrollLeft = scrollContainer.scrollLeft;
        }), 200);
      }
    }

    debounce(func, wait) {
      let timeout;
      return function(...args) {
        const later = () => {
          clearTimeout(timeout);
          func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    }

  });
}